/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum cabinTypeEnum {
  BALCONY = 'Balcony',
  JUNIOR_SUITE = 'JuniorSuite',
  INTERIOR = 'Interior',
  VERANDA = 'Veranda',
  SUITE = 'Suite',
  OUTSIDE = 'Outside',
  FAMILY = 'Family',
  DELUXE_SUITE = 'DeluxeSuite',
  PANORAMA_SUITE = 'PanoramaSuite',
  PANORAMA_BALCONY = 'PanoramaBalcony',
  FAMILY_BALCONY = 'FamilyBalcony',
  FAMILY_VERANDA = 'FamilyVeranda',
  SKY_SUITE = 'SkySuite',
  HORIZON_SUITE = 'HorizonSuite',
  VIEW_SUITE = 'ViewSuite',
  SPA_BALCONY = 'SpaBalcony',
  OVERSEA_SUITE = 'OverseaSuite',
  JUNIOR_SUITE_VERANDA = 'JuniorSuiteVeranda',
  VERANDA_SUITE = 'VerandaSuite',
  THEME_SUITE = 'ThemeSuite',
  COMBI_BALCONY = 'CombiBalcony',
}
